import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/input';

@Component({
  selector: 'app-ringover-settings',
  imports: [FormsModule, MatLabel, ReactiveFormsModule],
  templateUrl: './ringover-settings.component.html',
  styleUrl: '../call-integration-settings.scss',
})
export class RingoverSettingsComponent {
  @Input()
  form: FormGroup;

  @Input()
  isWebHookKeySet: boolean;

  @Input()
  isApiKeySet: boolean;
}
